import React from "react";
import clsx from "clsx";

export type IconActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const IconActionButton = ({
  className,
  type = "button",
  children,
  ...props
}: IconActionButtonProps) => {
  return (
    <button
      type={type}
      {...props}
      className={clsx(
        "inline-flex size-6 items-center justify-center rounded-full border-[3px] border-transparent bg-transparent text-neutral-500 transition-colors duration-150 [&>svg]:h-5 [&>svg]:w-5",
        "hover:border-primary-200 hover:bg-primary-200 hover:text-neutral-500",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-40",
        className,
      )}
    >
      {children}
    </button>
  );
};

export default IconActionButton;
